Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.Endian = module.exports.default = {
	BIG_ENDIAN: "bigEndian",
	LITTLE_ENDIAN: "littleEndian"
};